document.addEventListener('DOMContentLoaded', function () {
  const descriptions = document.querySelectorAll('.product__description');

  descriptions.forEach(function (description) {
    const headings = description.querySelectorAll('h2');

    if (!headings.length) return;

    headings.forEach(function (heading, index) {
      // Don't process the same heading twice
      if (heading.dataset.accordionProcessed === 'true') return;

      heading.dataset.accordionProcessed = 'true';

      // Create the accordion
      const details = document.createElement('details');
      details.className = 'product-description-accordion';

      const summary = document.createElement('summary');
      summary.className = 'product-description-accordion__summary';

      const title = document.createElement('span');
      title.className = 'product-description-accordion__title';
      title.innerHTML = heading.innerHTML;

      const icon = document.createElement('span');
      icon.className = 'product-description-accordion__icon';
      icon.setAttribute('aria-hidden', 'true');
      icon.textContent = '+';

      summary.appendChild(title);
      summary.appendChild(icon);

      details.appendChild(summary);

      // Collect everything after the H2 until the next H2
      let nextElement = heading.nextElementSibling;

      while (nextElement && nextElement.tagName.toLowerCase() !== 'h2') {
        const elementToMove = nextElement;
        nextElement = nextElement.nextElementSibling;

        details.appendChild(elementToMove);
      }

      // Replace the original H2 with the accordion
      heading.parentNode.replaceChild(details, heading);
    });
  });
});